import { Component, OnInit } from '@angular/core';
import { FirebaseService } from 'src/app/shared/firebase.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-maschinen-organical',
  templateUrl: './maschinen-organical.component.html',
  styleUrls: ['./maschinen-organical.component.scss']
})
export class MaschinenOrganicalComponent implements OnInit {

  constructor(
    private firebaseService: FirebaseService,
    private afs: AngularFirestore,
    ) { }

    HolderLeft;
    HolderLeft2;
    HolderRight;
    HolderRight2;

    HolderLeftBlank;
    HolderRightBlank;
    HolderLeftBlank2;
    HolderRightBlank2;

    millingtime;

    dateNow;
    timeleft;
    timedone;

  ngOnInit() {
    this.getHolderLeft();
    this.getHolderLeft2();
    this.getHolderRight();
    this.getHolderRight2();

    this.getHolderLeftBlank();
    this.getHolderRightBlank();
    this.getHolderLeftBlank2();
    this.getHolderRightBlank2();

    this.getTimenew();
    this.updatetime();
    this.setDatenow();
  }

  getTimenew = () =>
  this.firebaseService.getorgtime().subscribe(res => (this.millingtime = res))

  getHolderLeft = () =>
  this.firebaseService.getMachineUploadsORGleft().subscribe(res => (this.HolderLeft = res))

  getHolderLeft2 = () =>
  this.firebaseService.getMachineUploadsORGleft2().subscribe(res => (this.HolderLeft2 = res))

  getHolderRight = () =>
  this.firebaseService.getMachineUploadsORGright().subscribe(res => (this.HolderRight = res))

  getHolderRight2 = () =>
  this.firebaseService.getMachineUploadsORGright2().subscribe(res => (this.HolderRight2 = res))

  getHolderLeftBlank = () =>
  this.firebaseService.getMachineUploadsORGleftBlank().subscribe(res => (this.HolderLeftBlank = res))

  getHolderRightBlank = () =>
  this.firebaseService.getMachineUploadsORGrightBlank().subscribe(res => (this.HolderRightBlank = res))

  getHolderLeftBlank2 = () =>
  this.firebaseService.getMachineUploadsORGleftBlank2().subscribe(res => (this.HolderLeftBlank2 = res))

  getHolderRightBlank2 = () =>
  this.firebaseService.getMachineUploadsORGrightBlank2().subscribe(res => (this.HolderRightBlank2 = res))

  setreadystate = data =>
  this.firebaseService.setreadystate(data)

  setreadystate2 = data =>
  this.firebaseService.setreadystate2(data)

  Submit(data) {
  this.setreadystate(data);
  }
  Submit2(data) {
  this.setreadystate2(data);
  }

  moveBack(data) {
    this.setmoveback(data);
  }

  moveBack2(data) {
    this.setmoveback2(data); 
  }

  setmoveback = data =>
  this.firebaseService.setMovebackStatus(data)

  setmoveback2 = data =>
  this.firebaseService.setMovebackStatus2(data)

  setTime(data) {
    this.timesetter(data);
  }

  timesetter = data =>
  this.firebaseService.SetORGTimer(data)

  resttime (data) {
    this.timeleft = Date.now() - data.payload.doc.data().starttime;
  }


  updatetime() {
    this.dateNow = setInterval(() => { this.setDatenow(); }, 4000);
    
  }

  setDatenow () {
    this.dateNow = Date.now();
  }
}

